export const ConnectionTypeString = (speedtest, type) => {
	var text;

	switch (speedtest.ConnectionType) {

		case "wifi":
			text = (type === 1 || type === 3 ? "Wi-Fi" : "");
			if (speedtest.WiFiSSID && type !== 3)
				text += (type === 1 ? ": " : "")+speedtest.WiFiSSID.replace(/["]+/g, '');
			break;

		case "cellular":
			if (type === 3)
				text = "Mobile";
			else {
				text = speedtest.MobileSIMOperator;
				if (speedtest.MobileType !== "UNKNOWN")
					text += ", "+speedtest.MobileType;
			}
			break;

		default:
			if (type === 3)
				text = "LAN";
			else
				text = (type === 1 ? "LAN: " : "")+speedtest.Provider;

	}

	return text
}
